import api from '../utils/api';

export const getGateways = async () => {
  const response = await api.get('/gateways');
  return response.data;
};

export const getGateway = async (id) => {
  const response = await api.get(`/gateways/${id}`);
  return response.data;
};

/**
 * آمار درگاه: تعداد محصولات، سفارشات، مجموع فروش، آخرین فروش، انقضای توکن (دیجی‌کالا)
 */
export const getGatewayStats = async (id) => {
  const response = await api.get(`/gateways/${id}/stats`);
  return response.data;
};

export const getBasalamWebhooks = async (id) => {
  const response = await api.get(`/gateways/${id}/basalam-webhooks`);
  return response.data;
};

/**
 * لیست سفارشات دیجی‌کالا برای یک درگاه (page=1,size=50 به صورت پیش‌فرض در سرور)
 */
export const getGatewayDigikalaOrders = async (id) => {
  const response = await api.get(`/gateways/${id}/digikala-orders`);
  return response.data;
};

export const createGateway = async (gatewayData) => {
  const response = await api.post('/gateways', gatewayData);
  return response.data;
};

export const updateGateway = async (id, gatewayData) => {
  const response = await api.put(`/gateways/${id}`, gatewayData);
  return response.data;
};

export const deleteGateway = async (id) => {
  const response = await api.delete(`/gateways/${id}`);
  return response.data;
};

/**
 * تبدیل کد اعتبارسنجی دیجی‌کالا به Access/Refresh Token و ذخیره در درگاه
 */
export const exchangeDigikalaToken = async (gatewayId, verificationCode) => {
  const response = await api.put(`/gateways/${gatewayId}/digikala-token`, {
    verificationCode,
  });
  return response.data;
};

/**
 * وارد کردن محصولات پنل (دیجی‌کالا/باسلام) به اپ
 */
export const importGatewayProducts = async (gatewayId) => {
  const response = await api.post(`/gateways/${gatewayId}/import-products`);
  return response.data;
};

/**
 * دریافت آیدی مشتری/غرفه باسلام با Access Token (GET /v1/users/me)
 * در صورت منقضی بودن Access Token با Refresh Token تمدید و دوباره تلاش می‌کند.
 * برای پر کردن خودکار «آیدی پنل باسلام»؛ در صورت تمدید، توکن‌های جدید در پاسخ برمی‌گردد.
 */
export const getBasalamCustomerId = async (accessToken, refreshToken) => {
  const response = await api.post('/gateways/basalam-customer-id', {
    accessToken: accessToken?.trim?.() || accessToken,
    refreshToken: refreshToken?.trim?.() || refreshToken || undefined,
  });
  return response.data;
};

/**
 * لغو اتصال محصولات درگاه - حذف gatewayRefs مربوط به این درگاه از همه محصولات
 */
export const disconnectGatewayProducts = async (gatewayId) => {
  const response = await api.delete(`/gateways/${gatewayId}/disconnect-products`);
  return response.data;
};
